import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_edit",
  "use": "micro_edit-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_edit\"><path fill-rule=\"evenodd\" d=\"M6 1H2.062C1.476 1 1 1.476 1 2.062v5.876C1 8.524 1.476 9 2.062 9h5.876C8.524 9 9 8.524 9 7.938V4h-.882v4.056H2.017V2.019H6V1Zm3.64.067L10 .711 9.281 0l-.36.356-4.688 4.577-.36.356.72.711.359-.356L9.64 1.067Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol